import { Button } from "../../../design-system";
import React from "react";
import { HiOutlinePause, HiOutlinePlay } from "react-icons/hi2";
import { AlbumData, TrackData } from "../Playlist.types";

type TrackListPanelProps = {
  variant: "desktop" | "mobile";
  tracksData: TrackData[];
  visibleMobileTracks: TrackData[];
  topContent?: React.ReactNode;
  primaryTrackId?: string;
  isPlaying: boolean;
  albumData: AlbumData;
  onSelectTrack: (track: TrackData) => void;
  formatDuration: (durationSec?: number) => string;
  formatPlayCount: (playCount?: number) => string;
};

function TrackListPanel({
  variant,
  tracksData,
  visibleMobileTracks,
  topContent,
  primaryTrackId,
  isPlaying,
  albumData,
  onSelectTrack,
  formatDuration,
  formatPlayCount,
}: TrackListPanelProps) {
  if (variant === "desktop") {
    return (
      <section className="flex-1 overflow-auto pr-2">
        {topContent}
        <div className="space-y-2 pt-6">
          {tracksData.map((track, index) => {
            const selected = track.id === primaryTrackId;
            return (
              <Button variant="ghost" size="none"
                key={track.id}
                onClick={() => onSelectTrack(track)}
                className={`w-full rounded-xl px-5 py-3 text-left flex items-center gap-4 ${selected ? "bg-player-border/50" : "hover:bg-player-surface/70"
                  }`}
              >
                <span className="w-6 text-player-muted text-2xl text-center">
                  {selected ? (
                    isPlaying ? (
                      <HiOutlinePause size={20} />
                    ) : (
                      <HiOutlinePlay size={20} />
                    )
                  ) : (
                    index + 1
                  )}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-2xl truncate">
                    {track.title}
                  </p>
                  <p className="text-player-muted text-xl truncate">
                    {track.artistName || albumData.artistName || "Artista"}
                    {formatPlayCount(track.playCount)
                      ? ` • ${formatPlayCount(track.playCount)}`
                      : ""}
                  </p>
                </div>
                <span className="text-player-secondary text-2xl">
                  {formatDuration(track.durationSec)}
                </span>
              </Button>
            );
          })}
        </div>
      </section>
    );
  }

  return (
    <section className="mt-4 space-y-3 pb-12">
      {topContent}
      {visibleMobileTracks.map((track, index) => (
        <Button variant="ghost" size="none"
          key={`${track.id}-mobile`}
          onClick={() => onSelectTrack(track)}
          className="w-full text-left flex items-start gap-3"
        >
          <span className="w-6 text-control-hover text-2xl text-center mt-1">
            {index + 1}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-2xl font-semibold truncate">{track.title}</p>
            <p className="text-player-muted text-xl truncate">
              {track.artistName || albumData.artistName || "Artista"} •{" "}
              {formatDuration(track.durationSec)}
              {formatPlayCount(track.playCount)
                ? ` • ${formatPlayCount(track.playCount)}`
                : ""}
            </p>
          </div>
          <span className="text-player-secondary text-2xl mt-0.5">⋮</span>
        </Button>
      ))}
    </section>
  );
}

export default TrackListPanel;
